// Base URL (scheme + host + optional context path, no trailing slash) of
// vc-chatbot-authentication-service, which fronts Google OAuth login and
// proxies authenticated chat requests to the AWS Bedrock AgentCore runtime.
const DEFAULT_AUTH_SERVICE_URL =
  'https://api-apihub-dev.non-prod.vc-vcg.engineering.vodafone.com/authentication-service';

function stripTrailingSlash(value: string): string {
  return value.endsWith('/') ? value.slice(0, -1) : value;
}

export const AUTH_SERVICE_URL = stripTrailingSlash(
  import.meta.env.VITE_AUTH_SERVICE_URL?.trim() || DEFAULT_AUTH_SERVICE_URL,
);
